import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import Done from '@material-ui/icons/Done';
import { showNotification } from 'react-admin';
import { push } from 'react-router-redux';
import fetchOk from '../utils/fetchOk';

class BookingCameButton extends Component {
  state = {
    loading: false
  };

  handleClick = () => {
    const { push, record, showNotification } = this.props;
    const fetchHeaders = {
      'Authorization': `Bearer ${window.localStorage.getItem('token')}`,
      'X-HOTEL': process.env.REACT_APP_HOTEL
    };
    this.setState({loading: true});
    const entrypointUrl = new URL(process.env.REACT_APP_API_ENTRYPOINT);
    const came_uri = new URL(`${record.id}/came`, entrypointUrl);
    fetchOk(came_uri.toString(), {
      method: 'PATCH',
      headers: new Headers({
        ...fetchHeaders,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      })
    })
      .then(() => {
        showNotification('La venue est validée');
        push('/bookings');
      })
      .catch(() => {
        showNotification('Erreur : la venue ne peut être validée', 'warning')
      })
      .finally(() => {
        this.setState({loading: false});
      })
  }

  render() {
    if (!this.props.record.came)
      return <Button label="Venu" color="secondary" onClick={this.handleClick} disabled={this.state.loading}>
        <Done></Done>
        &nbsp;Venu
      </Button>;

    return null;
  }
}

export default connect(null, {
  showNotification,
  push,
})(BookingCameButton);
